import instance from "../../network/index"; // Import your axios instance

const getCampaigns = async (url) => {
  try {
    const response = await instance.get(`/api/v1/campaigns${url}`);

    return response.data;
  } catch (error) {
    console.error("Login error:", error);
    if (error.response) {
      console.error(
        `Error status: ${error.response.status}`,
        error.response.data
      );
    }
    throw error; // Rethrow the error if needed for further handling
  }
};

const getCampaignsById = async (id) => {
  try {
    const response = await instance.get(
      `/api/v1/campaigns/${id}?include=tasks`
    );

    return response.data;
  } catch (error) {
    console.error("Login error:", error);
    if (error.response) {
      console.error(
        `Error status: ${error.response.status}`,
        error.response.data
      );
    }
    throw error; // Rethrow the error if needed for further handling
  }
};

const getBrands = async () => {
  try {
    const response = await instance.get("/api/v1/brands");
    return response?.data;
  } catch (error) {
    if (error.response) {
      console.error(
        `Error status: ${error.response.status}`,
        error.response.data
      );
    }
    throw error; // Rethrow the error if needed for further handling
  }
};

const getTemplates = async (params) => {
  try {
    const response = await instance.get(`/api/v1/templates${params}`);
    return response?.data;
  } catch (error) {
    if (error.response) {
      console.error(
        `Error status: ${error.response.status}`,
        error.response.data
      );
    }
    throw error; // Rethrow the error if needed for further handling
  }
};

const getTemplatesBySteps = async (id) => {
  try {
    const response = await instance.get(
      `/api/v1/templates/${id}?include=phases`
    );
    return response?.data;
  } catch (error) {
    if (error.response) {
      console.error(
        `Error status: ${error.response.status}`,
        error.response.data
      );
    }
    throw error; // Rethrow the error if needed for further handling
  }
};

const getTemplatesDetails = async (id) => {
  try {
    const response = await instance.get(
      `/api/v1/templates/${id}?include=phases`
    );
    return response?.data?.data;
  } catch (error) {
    if (error.response) {
      console.error(
        `Error status: ${error.response.status}`,
        error.response.data
      );
    }
    throw error; // Rethrow the error if needed for further handling
  }
};
const createTemplate = async (payload) => {
  try {
    const response = await instance.post(`/api/v1/templates/`, payload);
    return response?.data?.data;
  } catch (error) {
    if (error.response) {
      console.error(
        `Error status: ${error.response.status}`,
        error.response.data
      );
    }
    throw error; // Rethrow the error if needed for further handling
  }
};

const deleteTemplateById = async (templateId) => {
  try {
    const response = await instance.delete(`/api/v1/templates/${templateId}`);

    if (response.status === 204) {
      return "Template deleted successfully";
    }

    return response?.data?.data;
  } catch (error) {
    if (error.response) {
      console.error(
        `Error status: ${error.response.status}`,
        error.response.data
      );
    }
    throw error; // Rethrow the error if needed for further handling
  }
};
const updateTemplateById = async (templateId, payload) => {
  try {
    const response = await instance.patch(
      `/api/v1/templates/${templateId}`,
      payload
    );

    if (response.status === 200) {
      return response?.data?.data;
    }

    return response?.data?.data;
  } catch (error) {
    if (error.response) {
      console.error(
        `Error status: ${error.response.status}`,
        error.response.data
      );
    }
    throw error; // Rethrow the error if needed for further handling
  }
};

const createCampaign = async (data) => {
  try {
    const response = await instance.post(`/api/v1/campaigns`, data);
    if (response?.status === 201) {
      return response?.data; // Return the full response data if needed
    }
    // Handle unexpected success responses
    console.warn("Unexpected response:", response);
    return null;
  } catch (error) {
    // Log additional details if error response exists
    if (error.response) {
      console.error(
        `Error status: ${error.response.status}`,
        error.response.data
      );
    }
    throw error; // Rethrow the error for further error handling
  }
};
const updateCampaign = async (id, data) => {
  try {
    const response = await instance.patch(`/api/v1/campaigns/${id}`, data);
    if (response?.status === 200) {
      return response?.data; // Return the full response data if needed
    }
    return null;
  } catch (error) {
    // Log additional details if error response exists
    if (error.response) {
      console.error(
        `Error status: ${error.response.status}`,
        error.response.data
      );
    }
    throw error; // Rethrow the error for further error handling
  }
};

const getAssets = async (params) => {
  try {
    const response = await instance.get(`/api/v1/assets${params}`);
    return response?.data?.data;
  } catch (error) {
    if (error.response) {
      console.error(
        `Error status: ${error.response.status}`,
        error.response.data
      );
    }
    throw error; // Rethrow the error if needed for further handling
  }
};

const addNotes = async (id, data) => {
  try {
    const response = await instance.post(`/api/v1/campaigns/${id}/notes`, data);
    return response?.data;
  } catch (error) {
    if (error.response) {
      console.error(
        `Error status: ${error.response.status}`,
        error.response.data
      );
    }
    throw error; // Rethrow the error if needed for further handling
  }
};

const updateNotes = async (id, data) => {
  try {
    const response = await instance.patch(
      `/api/v1/campaigns/${id}/notes`,
      data
    );
    return response?.data;
  } catch (error) {
    if (error.response) {
      console.error(
        `Error status: ${error.response.status}`,
        error.response.data
      );
    }
    throw error; // Rethrow the error if needed for further handling
  }
};
const getNotes = async (id) => {
  try {
    const response = await instance.get(`/api/v1/campaigns/${id}/notes`);
    return response?.data?.data;
  } catch (error) {
    if (error.response) {
      console.error(
        `Error status: ${error.response.status}`,
        error.response.data
      );
    }
    throw error; // Rethrow the error if needed for further handling
  }
};

async function getCampaignStats() {
  try {
    const response = await instance.get(`/api/v1/campaigns/stats`);
    
    return response?.data;
  } catch (error) {
    if (error.response) {
      console.error(
        `Error status: ${error.response.status}`,
        error.response.data
      );
    }
    throw error; // Rethrow the error if needed for further handling
  }
}

export {
  getCampaigns,
  getBrands,
  getTemplates,
  getTemplatesBySteps,
  createCampaign,
  getCampaignsById,
  getAssets,
  addNotes,
  getNotes,
  updateNotes,
  getCampaignStats,
  updateCampaign,
  getTemplatesDetails,
  createTemplate,
  deleteTemplateById,
  updateTemplateById,
};
